import { useQuery, keepPreviousData } from '@tanstack/react-query';
import * as api from '~/fetch';
import type { TenderofferPricingParams } from '~/fetch/tenders';

type Options = {
  tenderId?: string;
  orderId?: string;
  params?: TenderofferPricingParams;
  enabled?: boolean;
};

export const useTenderofferPricing = ({
  tenderId,
  orderId,
  params = {},
  enabled = true,
}: Options) =>
  useQuery({
    queryKey: ['tenderoffer-pricing', tenderId, orderId, params],
    queryFn: async () => {
      const response = await api.tenders.tenderofferPricing(
        tenderId!,
        orderId!,
        params
      );
      return api.utils.processResponse(response, {
        async 200(response) {
          return await response.json();
        },
        async default() {
          return null;
        },
      });
    },
    enabled: enabled && !!tenderId && !!orderId,
    placeholderData: keepPreviousData,
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
  });
